const showDocRoutes = [
  {
    path: '/ShowDoc',
    name: 'ShowDoc',
    component: () => import('@/pages/showpdf'),
    meta: {keepAlive: true, name: '查看文档'},
  },

]

export default showDocRoutes



// WEBPACK FOOTER //
// ./src/router/modules/showdoc.js